// This file is autogenerated by tools/genMaterialLibrary. DO NOT EDIT IT DIRECTLY.
export const TemplateIdToName = {
  "0": "Carpet",
  "1": "Color_PlanFloor",
  "10": "Grass_Lawn_01",
  "100": "X_CheckerTest",
  "101": "X_PerfTest01",
  "102": "X_ReflectionTest01",
  "103": "X_CheckerTest",
  "104": "Wall_ScaleShingle07",
  "105": "Wall_BoardBatten02hx16",
  "106": "Gravel",
  "107": "Floor_Vinyl_NaturalStone",
  "108": "OUTDATED_MATERIAL",
  "109": "Masonry_BrickModular",
  "11": "Gutter",
  "110": "Masonry_BrickModular_Header",
  "111": "Masonry_BrickModular_Rowlock",
  "112": "Masonry_Stone_Env_Cutstone",
  "113": "Masonry_Stone_TerraCut_05_Trim",
  "114": "Masonry_Stone_ProVia_TerraCut",
  "115": "Masonry_Stone_Limestone_05_Trim",
  "116": "Masonry_Stone_Limestone_OLD",
  "117": "Wall_BoardBatten03x08",
  "118": "Wall_BoardBatten03x48",
  "119": "Wall_BoardLap07_Grain",
  "12": "Metal_Powder",
  "120": "Masonry_Stone_Environmental_Cutstone_05_Trim",
  "121": "Masonry_BrickKing_Herringbone",
  "122": "Masonry_BrickModular_Herringbone",
  "123": "Masonry_BrickQueen_Herringbone",
  "124": "Wall_Tile06x12_Carrara",
  "125": "Wall_Tile",
  "126": "Wall_ShakeShingleStraight07",
  "127": "Roof_AsphaltBelmont",
  "128": "Roof_AsphaltCarriageHouse",
  "129": "CT_Landmark_Pro",
  "13": "Metal_Screen",
  "130": "Roof_AsphaltGrandManor",
  "131": "Roof_AsphaltHighlandSlate",
  "132": "Wall_BoardLap04",
  "133": "Masonry_Stone_Vener_Cobblestone_SolidTrim",
  "134": "Masonry_Stone_Cultured_CountryLedgestone_05_Trim",
  "135": "Masonry_Stone_Cultured_CountryLedgestone",
  "136": "Masonry_Stone_Eldorado_MountainLedge_05_Trim",
  "137": "Masonry_Stone_Eldorado_MountainLedge",
  "138": "Wall_BoardBatten02x16_Grain",
  "139": "Wall_BoardBatten02x16",
  "14": "Paint_Egg",
  "140": "Masonry_BrickKing_HalfHeight",
  "141": "Masonry_BrickQueen_HalfHeight",
  "142": "Masonry_Stone_RockMaterials_Sawn",
  "143": "Masonry_Stone_RockMaterials_05_Trim",
  "144": "Masonry_Stone_Weatherledge_05_Trim",
  "145": "Masonry_Stone_Weatherledge_OLD",
  "146": "Lattice_45deg_1x1",
  "147": "Masonry_BrickKing_ThinCut",
  "148": "Masonry_BrickQueen_ThinCut",
  "149": "Masonry_BrickEstate",
  "15": "Paint_Flat",
  "150": "Masonry_Stone_Environmental_Cutstone_24_Trim",
  "151": "Wall_BoardBatten02hx08",
  "152": "Wall_BoardBatten02hx12",
  "153": "Wall_ShakeShingle06",
  "154": "Roof_WoodShake_10x10",
  "155": "Roof_AsphaltShakeStraight",
  "156": "RoofTile_Capistrano",
  "157": "Wall_BoardLapAlternating04x07",
  "158": "Wall_BoardBatten01hx12",
  "159": "Wall_BoardBatten01hx16",
  "16": "Paint_Gloss",
  "160": "Wall_BoardBatten01hx24",
  "161": "Wall_BoardBatten01hx48",
  "162": "Wall_BoardBatten01x08",
  "163": "Wall_BoardBatten01x12",
  "164": "Wall_BoardBatten01x16",
  "165": "Wall_BoardBatten01x24",
  "166": "Wall_BoardBatten01x48",
  "167": "Wall_BoardBatten02hx24",
  "168": "Wall_BoardBatten02hx48",
  "169": "Wall_BoardBatten02x08",
  "17": "Paint_Satin",
  "170": "Wall_BoardBatten02x24",
  "171": "Wall_BoardBatten02x48",
  "172": "Wall_BoardBatten03hx08",
  "173": "Wall_BoardBatten03hx12",
  "174": "Wall_BoardBatten03hx16",
  "175": "Wall_BoardBatten03hx24",
  "176": "Wall_BoardBatten03hx48",
  "177": "Wall_BoardBatten03x12",
  "178": "Wall_BoardBatten03x16",
  "179": "Wall_BoardBatten03x24",
  "18": "Paint_SemiGloss",
  "180": "Wall_BoardBatten04hx08",
  "181": "Wall_BoardBatten04hx12",
  "182": "Wall_BoardBatten04hx16",
  "183": "Wall_BoardBatten04hx24",
  "184": "Wall_BoardBatten04hx48",
  "185": "Wall_BoardBatten04x08",
  "186": "Wall_BoardBatten04x12",
  "187": "Wall_BoardBatten04x16",
  "188": "Wall_BoardBatten04x24",
  "189": "Wall_BoardBatten04x48",
  "19": "Roof_Asphalt",
  "190": "Wall_BoardBatten05hx08",
  "191": "Wall_BoardBatten05hx12",
  "192": "Wall_BoardBatten05hx16",
  "193": "Wall_BoardBatten05hx24",
  "194": "Wall_BoardBatten05hx48",
  "195": "Wall_BoardBatten05x08",
  "196": "Wall_BoardBatten05x12",
  "197": "Wall_BoardBatten05x16",
  "198": "Wall_BoardBatten05x24",
  "199": "Wall_BoardBatten05x48",
  "2": "Color",
  "20": "Roof_Asphalt3Tab",
  "200": "Wall_BoardBatten06hx08",
  "201": "Wall_BoardBatten06hx12",
  "202": "Wall_BoardBatten06hx16",
  "203": "Wall_BoardBatten06hx24",
  "204": "Wall_BoardBatten06hx48",
  "205": "Wall_BoardBatten06x08",
  "206": "Wall_BoardBatten06x12",
  "207": "Wall_BoardBatten06x16",
  "208": "Wall_BoardBatten06x24",
  "209": "Wall_BoardBatten06x48",
  "21": "Roof_AsphaltShake",
  "210": "Masonry_Stone_12_Trim",
  "211": "Masonry_Stone_24_Trim",
  "212": "Masonry_Stone_Cultured_CountryLedgestone_03_Trim",
  "213": "Masonry_Stone_Cultured_CountryLedgestone_12_Trim",
  "214": "Masonry_Stone_Cultured_CountryLedgestone_24_Trim",
  "215": "Masonry_Stone_Eldorado_MountainLedge_03_Trim",
  "216": "Masonry_Stone_Eldorado_MountainLedge_12_Trim",
  "217": "Masonry_Stone_Eldorado_MountainLedge_24_Trim",
  "218": "Masonry_Stone_Environmental_Cutstone_03_Trim",
  "219": "Masonry_Stone_Environmental_Cutstone_12_Trim",
  "22": "Roof_Rubber",
  "220": "Masonry_Stone_Limestone_03_Trim",
  "221": "Masonry_Stone_Limestone_12_Trim",
  "222": "Masonry_Stone_Limestone_24_Trim",
  "223": "Masonry_Stone_RockMaterials_03_Trim",
  "224": "Masonry_Stone_RockMaterials_12_Trim",
  "225": "Masonry_Stone_RockMaterials_24_Trim",
  "226": "Masonry_Stone_TerraCut_03_Trim",
  "227": "Masonry_Stone_TerraCut_12_Trim",
  "228": "Masonry_Stone_TerraCut_24_Trim",
  "229": "Masonry_Stone_Vener_Cobblestone_05_Trim",
  "23": "Roof_StandingSeam12",
  "230": "Masonry_Stone_Vener_Cobblestone_12_Trim",
  "231": "Masonry_Stone_Vener_Cobblestone_24_Trim",
  "232": "Masonry_Stone_Weatherledge_03_Trim",
  "233": "Masonry_Stone_Weatherledge_12_Trim",
  "234": "Masonry_Stone_Weatherledge_24_Trim",
  "235": "Prop_BlackGlass",
  "236": "Wall_StuccoScored04",
  "237": "Wall_StuccoScored06",
  "238": "Wall_StuccoScored07",
  "239": "Wall_StuccoScored08",
  "24": "Roof_StandingSeam12",
  "240": "Wall_BoardBatten01hx20",
  "241": "Wall_BoardBatten01x20",
  "242": "Wall_BoardBatten02hx20",
  "243": "Wall_BoardBatten02x20",
  "244": "Wall_BoardBatten03hx20",
  "245": "Wall_BoardBatten03x20",
  "246": "Wall_BoardBatten04hx20",
  "247": "Wall_BoardBatten04x20",
  "248": "Wall_BoardBatten05hx20",
  "249": "Wall_BoardBatten05x20",
  "25": "Roof_StandingSeam16",
  "250": "Wall_BoardBatten06hx20",
  "251": "Wall_BoardBatten06x20",
  "252": "Wall_BoardLap04_Grain",
  "253": "Wall_BoardLap06_Grain",
  "254": "Wall_BoardLap08_Grain",
  "255": "Wall_ReverseBatten05hx01",
  "256": "Wall_BoardLapAlternating05x08",
  "257": "Roof_StandingSeam18",
  "258": "Masonry_Stone_Environmental_CreamChisel",
  "259": "Masonry_Stone_Environmental_CreamChisel_Trim",
  "26": "Roof_StandingSeamIR",
  "260": "Wall_BoardLap05_Grain",
  "261": "Wall_BoardLap05",
  "262": "Masonry_Stone_Environmental_CreamTivoli_Trim",
  "263": "Masonry_Stone_Environmental_CreamTivoli",
  "264": "Masonry_Stone_Environmental_GrezzoRosa_Trim",
  "265": "Masonry_Stone_Environmental_GrezzoRosa",
  "266": "Masonry_Stone_MountainLedge_GreyDrift_Trim",
  "267": "Masonry_Stone_MountainLedge_GreyDrift",
  "268": "Masonry_Stone_ProstackLite_IronSmoke_Trim",
  "269": "Masonry_Stone_ProstackLite_IronSmoke",
  "27": "Roof_StandingSeamPBU_Galvanized",
  "270": "Masonry_Stone_Sabbie_NereGrezzo_Trim",
  "271": "Masonry_Stone_Sabbie_NereGrezzo",
  "272": "Wall_HorizontalBoard04_Grain",
  "273": "Wall_HorizontalBoard05_Grain",
  "274": "Wall_HorizontalBoard05",
  "275": "Wall_HorizontalBoard05h_Grain",
  "276": "Wall_HorizontalBoard06_Grain",
  "277": "Wall_HorizontalBoard07_Grain",
  "278": "Wall_HorizontalBoard07",
  "279": "Wall_HorizontalBoard08_Grain",
  "28": "RoofTrim_AsphaltShingle",
  "280": "Wall_HorizontalBoard08",
  "281": "Wood_Sheathing96x48",
  "282": "Masonry_Stone_Cultured_SouthernLedgestone",
  "283": "Masonry_Stone_Eldorado_Cliffstone_OLD",
  "284": "Masonry_Stone_Eldorado_Roughcut",
  "285": "Masonry_Stone_Cultured_AlpineLedgestone",
  "286": "Masonry_Stone_Cultured_DrystackLedgestone",
  "287": "Masonry_Stone_Eldorado_EuropeanLedge",
  "288": "Masonry_Stone_Eldorado_RusticLedge",
  "289": "Masonry_Stone_General_03_Trim",
  "29": "RoofTrim_StandingSeam",
  "290": "Masonry_Stone_General_05_Trim",
  "291": "Masonry_Stone_General_12_Trim",
  "292": "Masonry_Stone_General_24_Trim",
  "293": "Masonry_Stone_ProVia_RidgeCut",
  "294": "Roof_WoodShake_10xVariable",
  "295": "Wall_HorizontalBoard02_01hx48vertical",
  "296": "Paver_Tpattern_6x6_6x9",
  "297": "Wall_BoardLap02_Grain",
  "298": "Wall_BoardLap02",
  "299": "Masonry_Stone_05_Trim_V",
  "3": "Floor_Concrete",
  "30": "RoofTrim_StandingSeam",
  "300": "Masonry_Stone_12_Trim_V",
  "301": "Masonry_Stone_24_Trim_V",
  "302": "Masonry_Stone_Cultured_CountryLedgestone_03_Trim_V",
  "303": "Masonry_Stone_Cultured_CountryLedgestone_05_Trim_V",
  "304": "Masonry_Stone_Cultured_CountryLedgestone_12_Trim_V",
  "305": "Masonry_Stone_Cultured_CountryLedgestone_24_Trim_V",
  "306": "Masonry_Stone_Eldorado_MountainLedge_03_Trim_V",
  "307": "Masonry_Stone_Eldorado_MountainLedge_05_Trim_V",
  "308": "Masonry_Stone_Eldorado_MountainLedge_12_Trim_V",
  "309": "Masonry_Stone_Eldorado_MountainLedge_24_Trim_V",
  "31": "RoofTrim_StandingSeam",
  "310": "Masonry_Stone_Environmental_CreamChisel_Trim_V",
  "311": "Masonry_Stone_Environmental_CreamTivoli_Trim_V",
  "312": "Masonry_Stone_Environmental_Cutstone_03_Trim_V",
  "313": "Masonry_Stone_Environmental_Cutstone_05_Trim_V",
  "314": "Masonry_Stone_Environmental_Cutstone_12_Trim_V",
  "315": "Masonry_Stone_Environmental_Cutstone_24_Trim_V",
  "316": "Masonry_Stone_Environmental_GrezzoRosa_Trim_V",
  "317": "Masonry_Stone_General_03_Trim_V",
  "318": "Masonry_Stone_General_05_Trim_V",
  "319": "Masonry_Stone_General_12_Trim_V",
  "32": "RoofTrim_StandingSeam",
  "320": "Masonry_Stone_General_24_Trim_V",
  "321": "Masonry_Stone_Limestone_03_Trim_V",
  "322": "Masonry_Stone_Limestone_05_Trim_V",
  "323": "Masonry_Stone_Limestone_12_Trim_V",
  "324": "Masonry_Stone_Limestone_24_Trim_V",
  "325": "Masonry_Stone_MountainLedge_GreyDrift_Trim_V",
  "326": "Masonry_Stone_ProstackLite_IronSmoke_Trim_V",
  "327": "Masonry_Stone_RockMaterials_03_Trim_V",
  "328": "Masonry_Stone_RockMaterials_05_Trim_V",
  "329": "Masonry_Stone_RockMaterials_12_Trim_V",
  "33": "Shutter",
  "330": "Masonry_Stone_RockMaterials_24_Trim_V",
  "331": "Masonry_Stone_Sabbie_NereGrezzo_Trim_V",
  "332": "Masonry_Stone_TerraCut_03_Trim_V",
  "333": "Masonry_Stone_TerraCut_05_Trim_V",
  "334": "Masonry_Stone_TerraCut_12_Trim_V",
  "335": "Masonry_Stone_TerraCut_24_Trim_V",
  "336": "Masonry_Stone_Vener_Cobblestone_03_Trim_V",
  "337": "Masonry_Stone_Vener_Cobblestone_05_Trim_V",
  "338": "Masonry_Stone_Vener_Cobblestone_12_Trim_V",
  "339": "Masonry_Stone_Vener_Cobblestone_24_Trim_V",
  "34": "Soffit_Slat",
  "340": "Masonry_Stone_Weatherledge_03_Trim_V",
  "341": "Masonry_Stone_Weatherledge_05_Trim_V",
  "342": "Masonry_Stone_Weatherledge_12_Trim_V",
  "343": "Masonry_Stone_Weatherledge_24_Trim_V",
  "344": "Masonry_Stone_Ledgestone_03_Trim_V",
  "345": "Masonry_Stone_Ledgestone_03_Trim",
  "346": "Masonry_Stone_Ledgestone_05_Trim_V",
  "347": "Masonry_Stone_Ledgestone_05_Trim",
  "348": "Masonry_Stone_Ledgestone_12_Trim_V",
  "349": "Masonry_Stone_Ledgestone_12_Trim",
  "35": "Stain_Flat",
  "350": "Masonry_Stone_Ledgestone_24_Trim_V",
  "351": "Masonry_Stone_Ledgestone_24_Trim",
  "352": "Masonry_Stone_Ledgestone_OLD",
  "353": "Wall_BoardLap04h_Dutch",
  "354": "Masonry_BrickExecutive_HalfHeight",
  "355": "Masonry_BrickExecutive_Header",
  "356": "Masonry_BrickExecutive_Herringbone",
  "357": "Masonry_BrickExecutive_Rowlock",
  "358": "Masonry_BrickExecutive_ThinCut",
  "359": "Masonry_BrickExecutive",
  "36": "Tree_Bark_Generic",
  "360": "SolarPanel_6x6",
  "361": "Stone_BlancoBuilders",
  "362": "Stone_RattlesnakeBuilders",
  "363": "Stone_SunflowerChop",
  "364": "Stone_TexasMix",
  "365": "Stone_TumbleweedTan",
  "366": "Masonry_Stone_RoughAshlar",
  "367": "Masonry_Stone_RM_Chopped",
  "368": "RoofTile_Elabana",
  "369": "Wall_StuccoScored10",
  "37": "Tree_Foliage_Generic",
  "370": "Wall_StuccoScored12",
  "371": "Wall_StuccoScored14",
  "372": "Wall_StuccoScored16",
  "373": "Wall_StuccoScored18",
  "374": "Wall_StuccoScored20",
  "375": "Wall_StuccoScored22",
  "376": "Wall_StuccoScored24",
  "377": "Masonry_Stone_ProVia_NaturalCut",
  "378": "Masonry_Stone_ProVia_PrecisionFit",
  "379": "Masonry_BrickModular_Weave3",
  "38": "X_CheckerTest",
  "380": "Masonry_BrickModular_HalfHeight",
  "381": "Wall_BoardBatten01hx06q",
  "382": "Masonry_Stone_Drystack",
  "383": "Masonry_Stone_Cobblestone",
  "384": "Masonry_Stone_Fieldstone",
  "385": "Wall_BoardBatten01hx07",
  "386": "Wall_BoardBatten01x07",
  "387": "Wall_BoardBatten02hx07",
  "388": "Wall_BoardBatten02x07",
  "389": "Wall_BoardBatten03hx07",
  "39": "Wood_Generic",
  "390": "Wall_BoardBatten03x07",
  "391": "Wall_BoardBatten04hx07",
  "392": "Wall_BoardBatten04x07",
  "393": "Wall_BoardBatten05hx07",
  "394": "Wall_BoardBatten05x07",
  "395": "Wall_BoardBatten06hx07",
  "396": "Wall_BoardBatten06x07",
  "397": "Wall_BoardLap12_Grain",
  "398": "Wall_BoardLap12",
  "399": "Wall_ShakeShingleStraight05",
  "4": "Floor_Tile_Carrara",
  "40": "X_CheckerTest",
  "400": "Wall_ShakeShingleStraight06",
  "401": "Wall_BoardBatten02hx09",
  "402": "Masonry_Stone_StackLedge",
  "403": "Patio_Stone_01",
  "404": "Roof_MetalShakeStraight12",
  "405": "Masonry_Stone_MV_HackettStone",
  "406": "Masonry_Stone_MV_StackStone",
  "407": "Masonry_Stone_CDS_Blend",
  "408": "Masonry_Stone_CDS_CountryRubble",
  "409": "Masonry_Stone_Ledgestone",
  "41": "Wall_BoardBatten01hx08",
  "410": "Masonry_Stone_CDS_Volterra",
  "411": "Masonry_Stone_PV_WesternLedge",
  "412": "Masonry_Stone_General_16_Trim_V",
  "413": "Masonry_Stone_General_16_Trim",
  "414": "Masonry_Stone_RM_Bluebonnet",
  "415": "Masonry_Stone_RM_Sawn",
  "416": "Masonry_Stone_RM_ChoppedLimestone",
  "417": "Wall_ShakeShingle09",
  "418": "Wall_HorizontalBoard08_Angle45L",
  "419": "Wall_HorizontalBoard08_Angle45R",
  "42": "Wall_BoardBatten01hx08",
  "420": "Asphalt_Default",
  "421": "Metal_Galvanized_01",
  "422": "Masonry_Stone_General_Trim",
  "423": "Roof_StandingSeam15",
  "424": "Masonry_Stone_General_Trim_V",
  "425": "Masonry_Stone_Limestone",
  "426": "Masonry_Stone_PS_OldCountyLedge",
  "427": "Masonry_Stone_PS_SouthernLimestone",
  "428": "Masonry_Stone_Weatherledge",
  "429": "Wall_BoardBatten01hx36",
  "43": "Wall_BoardBatten02x12",
  "430": "Wall_BoardBatten01x36",
  "431": "Wall_BoardBatten02hx36",
  "432": "Wall_BoardBatten02x36",
  "433": "Wall_BoardBatten03hx36",
  "434": "Wall_BoardBatten03x36",
  "435": "Wall_BoardBatten04hx36",
  "436": "Wall_BoardBatten04x36",
  "437": "Wall_BoardBatten05hx36",
  "438": "Wall_BoardBatten05x36",
  "439": "Wall_BoardBatten06hx36",
  "44": "Wall_BoardLap06",
  "440": "Wall_BoardBatten06x36",
  "441": "Wall_VerticalBoard02_Grain",
  "442": "Wall_VerticalBoard04_Grain",
  "443": "Wall_VerticalBoard05_Grain",
  "444": "Wall_VerticalBoard05H_Grain",
  "445": "Wall_VerticalBoard06_Grain",
  "446": "Wall_VerticalBoard08_Grain",
  "447": "Masonry_Stone_General_20_Trim_V",
  "448": "Masonry_Stone_General_20_Trim",
  "449": "Masonry_Stone_Eldorado_Ridgetop",
  "45": "Wall_BoardLap07",
  "450": "RoofTile_Slate",
  "451": "Masonry_Stone_Weatherledge_08_Trim_V",
  "452": "Masonry_Stone_Weatherledge_08_Trim",
  "453": "Masonry_Stone_PlyGem_CanyonLedge",
  "454": "Masonry_Stone_Eco_CountryRidge",
  "455": "Masonry_Stone_Eldorado_FieldLedge",
  "456": "Masonry_Stone_Eco_Ridgestone",
  "457": "Masonry_Stone_Eldorado_TundraBrick",
  "458": "Masonry_BrickDoubleMonarch_StackBond",
  "459": "Roof_StandingSeam24",
  "46": "Wall_BoardLap08",
  "460": "Masonry_Stone_PlyGem_Manorstone",
  "461": "Roof_StandingSeam14",
  "462": "Wall_BoardLap06_Gap01h",
  "463": "Wall_VerticalBoard06_Beaded01h",
  "464": "Masonry_Stone_DQ_Limestone",
  "465": "Masonry_Stone_DQ_RoughAshlar",
  "466": "Masonry_Stone_MES_SoutheasternLedge",
  "467": "Masonry_Stone_MES_StackedStone",
  "468": "Masonry_Stone_MES_Weatheredledge",
  "469": "Masonry_Stone_BC_StoneVeneerSangria",
  "47": "Masonry_Brick_03_Header",
  "470": "Masonry_BrickEngineer",
  "471": "Masonry_Stone_Eldorado_StackedStone",
  "472": "Masonry_Stone_Eldorado_Cliffstone",
  "473": "Masonry_CinderBlock08x16",
  "474": "Masonry_Stone_Harristone_Divino",
  "475": "Masonry_Stone_Harristone_Drystone",
  "476": "Masonry_Stone_Harristone_Leuders",
  "477": "Masonry_Stone_Harristone_Uintah",
  "478": "Masonry_Stone_Stonecraft_Ledgestone",
  "479": "Wall_Board48x120_Battens02h",
  "48": "Masonry_Brick_03_Rowlock",
  "480": "Masonry_Stone_MES_Cobblestone",
  "481": "Masonry_Stone_Eldorado_StackedStone",
  "482": "Masonry_Stone_Eldorado_Cliffstone",
  "483": "Floor_Vinyl",
  "484": "Masonry_Stone_Horizon_19thCenturyStone",
  "485": "Wall_BoardLap10_Grain",
  "486": "Wall_BoardLap10",
  "487": "Wall_BoardBatten02hx16_Grain",
  "488": "Masonry_Stone_Centurion_Elkmont",
  "489": "Masonry_Stone_DQ_Drystack",
  "49": "Masonry_Brick_03",
  "490": "Wood_Generic_V",
  "491": "Metal_Screen_Black",
  "492": "Floor_ConcreteBroomFinish",
  "493": "Masonry_Stone_Eldorado_Limestone",
  "494": "Masonry_Stone_QR_Cobblestone",
  "495": "Masonry_Stone_QR_CountryLedgestone",
  "496": "Masonry_Stone_QR_WeatheredEdge",
  "497": "Metal_Grate",
  "498": "Masonry_Stone_QR_RusticLedgestone",
  "499": "Tile_17x17",
  "5": "Floor_Tile",
  "50": "Masonry_Brick_05_Header",
  "500": "Wall_BoardLap04h",
  "501": "Masonry_Stone_SCM_Hackett",
  "502": "Masonry_Stone_SCM_LimeStackMix",
  "503": "Masonry_Stone_SCM_RomanCastle",
  "504": "Masonry_Stone_SCM_StackStone",
  "505": "Masonry_Stone_General_48_Trim_V",
  "506": "Masonry_Stone_General_48_Trim",
  "507": "Tile_12x12",
  "508": "TileBath_4x12",
  "509": "Masonry_Stone_ProVia_Edgecut",
  "51": "Masonry_Brick_05_Rowlock",
  "510": "Masonry_Stone_General_08_Trim_V",
  "511": "Masonry_Stone_General_08_Trim",
  "512": "Masonry_Stone_BC_MontanaLedge",
  "513": "Masonry_Stone_BC_OhioRubble",
  "514": "Masonry_Stone_BC_PrairieBluff",
  "515": "Masonry_Stone_Eldorado_CoarseCutStone",
  "516": "Masonry_Stone_Eldorado_CypressRidge",
  "517": "Masonry_Stone_BC_CountryLedge",
  "518": "Masonry_Stone_ProVia_Limestone",
  "519": "Masonry_Stone_Env_Ledgestone",
  "52": "Masonry_Brick_05",
  "520": "Masonry_Stone_PlyGem_ShadowLedgestone",
  "521": "X_FrostedGlass",
  "522": "Masonry_Stone_Centurion_Stack",
  "523": "Masonry_Stone_DQ_StackLedge",
  "524": "Masonry_Stone_DQ_Ledgestone",
  "525": "Masonry_Stone_DQ_Weatherledge",
  "526": "Masonry_Stone_Eldorado_SierraCut",
  "527": "Masonry_Stone_FDL_Biltmore",
  "528": "Masonry_Stone_FDL_Country",
  "529": "Masonry_Stone_Bello_Cobblestone",
  "53": "Masonry_Brick_075_Header",
  "530": "Masonry_Stone_Bello_Fieldstone",
  "531": "Masonry_Stone_Bello_Ledgestone",
  "532": "Masonry_Stone_BrandCo_Drystack",
  "533": "Masonry_Stone_BrandCo_Ledgestone",
  "534": "Masonry_Stone_CDS_Ledgestone",
  "535": "Masonry_Stone_CH_ChiseledEdge",
  "536": "Masonry_Stone_Cobra_TexasLimestone",
  "537": "Masonry_Stone_Harristone_Limestone",
  "538": "Masonry_Stone_MV_Ledgestone",
  "539": "Masonry_Stone_MV_Limestone",
  "54": "Masonry_Brick_075_Rowlock",
  "540": "Masonry_Stone_PlyGem_Fieldstone",
  "541": "Masonry_Stone_PlyGem_CascadeLedge",
  "542": "Masonry_Stone_PS_Weatherledge",
  "543": "Masonry_Stone_Prostone_Ledgestone",
  "544": "Masonry_Stone_PV_Ledgestone",
  "545": "Masonry_Stone_QR_DressedFieldstone",
  "546": "Masonry_Stone_Env_Chisel",
  "547": "Masonry_Stone_Env_Fieldstone",
  "548": "Masonry_Stone_Env_Grezzo",
  "549": "Masonry_Stone_Env_ProstackLite",
  "55": "Masonry_Brick_075",
  "550": "Masonry_Stone_Env_Tivoli",
  "551": "Masonry_Stone_IS_Fieldstone",
  "552": "Masonry_Stone_QS_Fieldstone",
  "553": "Masonry_Stone_Premier_Stack",
  "554": "Wall_PanelBoard_48x24",
  "555": "Wall_PanelBoard_V_48",
  "556": "Masonry_Stone_Centurion_Hackett",
  "557": "Masonry_Stone_Centurion_Ledgestone",
  "558": "Masonry_Stone_Centurion_Rubble",
  "559": "Masonry_Stone_Cultured_Limestone",
  "56": "Masonry_Brick_Bracciano_Header",
  "560": "Masonry_Stone_DP_Vener_Cobblestone",
  "561": "Masonry_Stone_Eldorado_Bluffstone",
  "562": "Masonry_Stone_Halquist_Ledge",
  "563": "Masonry_Stone_Harristone_Tumbled",
  "564": "Masonry_Stone_Lurveys_Cobblestone",
  "565": "Masonry_Stone_Metrobrick_Limestone",
  "566": "Masonry_Stone_MGBS_AustinLimestone",
  "567": "Masonry_Stone_MGBS_LeudersLimestone",
  "568": "Masonry_Stone_MGBS_LimestoneBlends",
  "569": "Masonry_Stone_Pioneer_StackEase",
  "57": "Masonry_Brick_Bracciano_Rowlock",
  "570": "Masonry_Stone_ProVia_ChiselCut",
  "571": "Masonry_Stone_ProVia_DryStack",
  "572": "Masonry_Stone_ProVia_Ledgestone",
  "573": "Masonry_Stone_QS_Cobblestone",
  "574": "Masonry_Stone_QS_Drystack",
  "575": "Masonry_Stone_RM_SawnBuilding",
  "576": "Masonry_Stone_RM_Waterford",
  "577": "Masonry_Stone_SCM_3_5Ledgestone",
  "578": "Masonry_Stone_SCM_CastleStone",
  "579": "Masonry_Stone_SCM_EuropeanCastle",
  "58": "Masonry_Brick_Bracciano",
  "580": "Masonry_Stone_SCM_EuropeanCobble",
  "581": "Masonry_Stone_SCM_KCBlend",
  "582": "Masonry_Stone_SCM_Ledgestone",
  "583": "Masonry_Stone_SCM_Limestone",
  "584": "Masonry_Stone_SCM_MidwestQuickfit",
  "585": "Masonry_Stone_SCM_MountainRubble",
  "586": "Masonry_Stone_SCM_Quickfit",
  "587": "Masonry_Stone_SCM_SawtoothLedge",
  "588": "Masonry_Stone_SCM_SouthernLedge",
  "589": "Masonry_Stone_SCM_StackHackett",
  "59": "Masonry_BrickKing_Header",
  "590": "Masonry_Stone_SCM_ThinkBrick",
  "591": "Masonry_Stone_Versetta_Ledgestone",
  "592": "Wall_BoardLap03_Grain",
  "593": "Wall_BoardLap03",
  "594": "Wall_VerticalBoard03_Grain",
  "595": "Wall_VerticalBoard03",
  "596": "Masonry_Stone_Env_CleanBrick",
  "597": "Masonry_Stone_Env_Hackett",
  "598": "Masonry_Stone_Env_Ripiano",
  "599": "Masonry_Stone_Env_SouthernLedgestone",
  "6": "Floor_Wood",
  "60": "Masonry_BrickKing_Rowlock",
  "600": "Masonry_Stone_Env_TuscanLedgestone",
  "601": "Masonry_Stone_Env_Weatheredge",
  "602": "Masonry_Stone_Env_Luxor",
  "603": "Masonry_Stone_Env_PrairieBrick",
  "604": "Masonry_Stone_Env_TumbledBrick",
  "61": "Masonry_BrickKing",
  "62": "Masonry_BrickQueen_Header",
  "63": "Masonry_BrickQueen_Rowlock",
  "64": "Masonry_BrickQueen",
  "65": "Wall_StaggerBoard05",
  "66": "Wall_HorizontalBoard04",
  "67": "Wall_HorizontalBoard05h_Grain",
  "68": "Wall_HorizontalBoard06",
  "69": "Masonry_Porcelain_Mandarin_CementoLightGrey",
  "7": "Garage",
  "70": "X_CheckerTest",
  "71": "X_CheckerTest",
  "72": "X_CheckerTest",
  "73": "Wall_ShakeShingle07",
  "74": "Masonry_Stone_Eldorado_Monument",
  "75": "Masonry_Stone_Ledgestone_Breakwater",
  "76": "Masonry_Stone_Premier_HavannaRubble",
  "77": "Masonry_Stone_Prostone_Sawgrass",
  "78": "Masonry_Stone_05_Trim",
  "79": "Masonry_Stone_Vener_Cobblestone_03_Trim",
  "8": "Glass_Base",
  "80": "Masonry_Stone_Vener_Cobblestone",
  "81": "Masonry_Stone",
  "82": "Masonry_StoneField_Tan",
  "83": "Masonry_StoneLimestone_Banks",
  "84": "Masonry_StoneLimestone_Bridgeport",
  "85": "Masonry_StoneMixedStack_GrayWarm",
  "86": "Masonry_StoneRoughCut_Moonlight",
  "87": "Masonry_StoneThinStack_Gray",
  "88": "Wall_Stucco",
  "89": "Wall_StuccoFine",
  "9": "Grass_Lawn_01",
  "90": "Wall_VerticalBoard02",
  "91": "Wall_VerticalBoard04",
  "92": "Wall_VerticalBoard05",
  "93": "Wall_VerticalBoard05H",
  "94": "Wall_VerticalBoard06",
  "95": "Wall_VerticalBoard08",
  "96": "X_CheckerTest",
  "97": "Window",
  "98": "Wood_HorizontalPlank",
  "99": "Wood_StaggeredPlank",
};
